import { createFileRoute } from "@tanstack/react-router";
import FounderPhase0 from "@/pages/FounderPhase0";
import RoleGate from "@/components/auth/RoleGate";

export const Route = createFileRoute("/accelerator/phase-0/")({
  component: () => (
    <RoleGate allow={['founder', 'staff']} area="Phase 0"><FounderPhase0 /></RoleGate>
  ),
});
